import React, { ReactNode } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import TabsHeader from '../TabsHeader';
import BodyContent from '../../BodyContent';

type AdminContainerProps = {
  children: ReactNode;
  headerTitle?: string;
  id?: number;
  type?: string;
  credentialState?: number;
  ssoUserId?: string | null;
  roles?: string[] | null;
  userId?: number | null;
  extraData?: any;
};

function AdminContainer( {
  children, headerTitle, type, id, credentialState, ssoUserId, roles, userId, extraData = null,
}: AdminContainerProps ) {
  return (
    <Container fluid="lg" className="body-container body-admin-container">
      <BodyContent>
        <TabsHeader
          title={headerTitle}
          type={type}
          id={id}
          credentialState={credentialState}
          ssoUserId={ssoUserId}
          roles={roles}
          userId={userId}
          extraData={extraData}
        />
        <Row>
          <Col>
            {children}
          </Col>
        </Row>
      </BodyContent>
    </Container>
  );
}

export default AdminContainer;
